/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as HelpRouteImport } from './routes/help'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RecoveryRouteImport } from './routes/recovery'
import { Route as RegistrationRouteImport } from './routes/registration'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as AuthAccountIndexRouteImport } from './routes/_auth.account/index'
import { Route as AuthAdministrationIndexRouteImport } from './routes/_auth.administration/index'
import { Route as AuthCoverageMapIndexRouteImport } from './routes/_auth.coverage-map/index'
import { Route as AuthDevicesIndexRouteImport } from './routes/_auth.devices/index'
import { Route as AuthDevicesUsernameRouteImport } from './routes/_auth.devices/$username'
import { Route as AuthDevicesBulkManagementRouteImport } from './routes/_auth.devices/bulk-management'
import { Route as AuthDevicesCreateRouteImport } from './routes/_auth.devices/create'
import { Route as AuthPartnersIndexRouteImport } from './routes/_auth.partners/index'
import { Route as AuthPartnersPartnerIdRouteImport } from './routes/_auth.partners/$partnerId'
import { Route as AuthPartnersCreateRouteImport } from './routes/_auth.partners/create'
import { Route as AuthSubscribersIndexRouteImport } from './routes/_auth.subscribers/index'
import { Route as AuthSubscribersSubscriberIdRouteImport } from './routes/_auth.subscribers/$subscriberId'
import { Route as AuthSubscribersCreateRouteImport } from './routes/_auth.subscribers/create'
import { Route as AuthUsageIndexRouteImport } from './routes/_auth.usage/index'
import { Route as AuthAdministrationApikeysIndexRouteImport } from './routes/_auth.administration/apikeys/index'
import { Route as AuthAdministrationAuthGroupsIndexRouteImport } from './routes/_auth.administration/auth-groups/index'
import { Route as AuthAdministrationAuthGroupsAuthGroupIdRouteImport } from './routes/_auth.administration/auth-groups/$authGroupId'
import { Route as AuthAdministrationAuthGroupsCreateRouteImport } from './routes/_auth.administration/auth-groups/create'
import { Route as AuthAdministrationCertificatesIndexRouteImport } from './routes/_auth.administration/certificates/index'
import { Route as AuthAdministrationCertificatesIdRouteImport } from './routes/_auth.administration/certificates/$id'
import { Route as AuthAdministrationCertificatesCreateRouteImport } from './routes/_auth.administration/certificates/create'
import { Route as AuthAdministrationUsersIndexRouteImport } from './routes/_auth.administration/users/index'
import { Route as AuthAdministrationUsersUserIdRouteImport } from './routes/_auth.administration/users/$userId'
import { Route as AuthAdministrationUsersCreateRouteImport } from './routes/_auth.administration/users/create'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpRoute = HelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RecoveryRoute = RecoveryRouteImport.update({
  id: '/recovery',
  path: '/recovery',
  getParentRoute: () => rootRouteImport,
} as any)
const RegistrationRoute = RegistrationRouteImport.update({
  id: '/registration',
  path: '/registration',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAccountIndexRoute = AuthAccountIndexRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdministrationIndexRoute = AuthAdministrationIndexRouteImport.update({
  id: '/administration/',
  path: '/administration/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCoverageMapIndexRoute = AuthCoverageMapIndexRouteImport.update({
  id: '/coverage-map/',
  path: '/coverage-map/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDevicesIndexRoute = AuthDevicesIndexRouteImport.update({
  id: '/devices/',
  path: '/devices/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDevicesUsernameRoute = AuthDevicesUsernameRouteImport.update({
  id: '/devices/$username',
  path: '/devices/$username',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDevicesBulkManagementRoute =
  AuthDevicesBulkManagementRouteImport.update({
    id: '/devices/bulk-management',
    path: '/devices/bulk-management',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDevicesCreateRoute = AuthDevicesCreateRouteImport.update({
  id: '/devices/create',
  path: '/devices/create',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPartnersIndexRoute = AuthPartnersIndexRouteImport.update({
  id: '/partners/',
  path: '/partners/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPartnersPartnerIdRoute = AuthPartnersPartnerIdRouteImport.update({
  id: '/partners/$partnerId',
  path: '/partners/$partnerId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPartnersCreateRoute = AuthPartnersCreateRouteImport.update({
  id: '/partners/create',
  path: '/partners/create',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSubscribersIndexRoute = AuthSubscribersIndexRouteImport.update({
  id: '/subscribers/',
  path: '/subscribers/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSubscribersSubscriberIdRoute =
  AuthSubscribersSubscriberIdRouteImport.update({
    id: '/subscribers/$subscriberId',
    path: '/subscribers/$subscriberId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSubscribersCreateRoute = AuthSubscribersCreateRouteImport.update({
  id: '/subscribers/create',
  path: '/subscribers/create',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsageIndexRoute = AuthUsageIndexRouteImport.update({
  id: '/usage/',
  path: '/usage/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdministrationApikeysIndexRoute =
  AuthAdministrationApikeysIndexRouteImport.update({
    id: '/administration/apikeys/',
    path: '/administration/apikeys/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAdministrationAuthGroupsIndexRoute =
  AuthAdministrationAuthGroupsIndexRouteImport.update({
    id: '/administration/auth-groups/',
    path: '/administration/auth-groups/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAdministrationAuthGroupsAuthGroupIdRoute =
  AuthAdministrationAuthGroupsAuthGroupIdRouteImport.update({
    id: '/administration/auth-groups/$authGroupId',
    path: '/administration/auth-groups/$authGroupId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAdministrationAuthGroupsCreateRoute =
  AuthAdministrationAuthGroupsCreateRouteImport.update({
    id: '/administration/auth-groups/create',
    path: '/administration/auth-groups/create',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAdministrationCertificatesIndexRoute =
  AuthAdministrationCertificatesIndexRouteImport.update({
    id: '/administration/certificates/',
    path: '/administration/certificates/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAdministrationCertificatesIdRoute =
  AuthAdministrationCertificatesIdRouteImport.update({
    id: '/administration/certificates/$id',
    path: '/administration/certificates/$id',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAdministrationCertificatesCreateRoute =
  AuthAdministrationCertificatesCreateRouteImport.update({
    id: '/administration/certificates/create',
    path: '/administration/certificates/create',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAdministrationUsersIndexRoute =
  AuthAdministrationUsersIndexRouteImport.update({
    id: '/administration/users/',
    path: '/administration/users/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAdministrationUsersUserIdRoute =
  AuthAdministrationUsersUserIdRouteImport.update({
    id: '/administration/users/$userId',
    path: '/administration/users/$userId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAdministrationUsersCreateRoute =
  AuthAdministrationUsersCreateRouteImport.update({
    id: '/administration/users/create',
    path: '/administration/users/create',
    getParentRoute: () => AuthRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/help': typeof HelpRoute
  '/login': typeof LoginRoute
  '/recovery': typeof RecoveryRoute
  '/registration': typeof RegistrationRoute
  '/settings': typeof SettingsRoute
  '/devices/$username': typeof AuthDevicesUsernameRoute
  '/devices/bulk-management': typeof AuthDevicesBulkManagementRoute
  '/devices/create': typeof AuthDevicesCreateRoute
  '/partners/$partnerId': typeof AuthPartnersPartnerIdRoute
  '/partners/create': typeof AuthPartnersCreateRoute
  '/subscribers/$subscriberId': typeof AuthSubscribersSubscriberIdRoute
  '/subscribers/create': typeof AuthSubscribersCreateRoute
  '/account/': typeof AuthAccountIndexRoute
  '/administration/': typeof AuthAdministrationIndexRoute
  '/coverage-map/': typeof AuthCoverageMapIndexRoute
  '/devices/': typeof AuthDevicesIndexRoute
  '/partners/': typeof AuthPartnersIndexRoute
  '/subscribers/': typeof AuthSubscribersIndexRoute
  '/usage/': typeof AuthUsageIndexRoute
  '/administration/auth-groups/$authGroupId': typeof AuthAdministrationAuthGroupsAuthGroupIdRoute
  '/administration/auth-groups/create': typeof AuthAdministrationAuthGroupsCreateRoute
  '/administration/certificates/$id': typeof AuthAdministrationCertificatesIdRoute
  '/administration/certificates/create': typeof AuthAdministrationCertificatesCreateRoute
  '/administration/users/$userId': typeof AuthAdministrationUsersUserIdRoute
  '/administration/users/create': typeof AuthAdministrationUsersCreateRoute
  '/administration/apikeys/': typeof AuthAdministrationApikeysIndexRoute
  '/administration/auth-groups/': typeof AuthAdministrationAuthGroupsIndexRoute
  '/administration/certificates/': typeof AuthAdministrationCertificatesIndexRoute
  '/administration/users/': typeof AuthAdministrationUsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/help': typeof HelpRoute
  '/login': typeof LoginRoute
  '/recovery': typeof RecoveryRoute
  '/registration': typeof RegistrationRoute
  '/settings': typeof SettingsRoute
  '/devices/$username': typeof AuthDevicesUsernameRoute
  '/devices/bulk-management': typeof AuthDevicesBulkManagementRoute
  '/devices/create': typeof AuthDevicesCreateRoute
  '/partners/$partnerId': typeof AuthPartnersPartnerIdRoute
  '/partners/create': typeof AuthPartnersCreateRoute
  '/subscribers/$subscriberId': typeof AuthSubscribersSubscriberIdRoute
  '/subscribers/create': typeof AuthSubscribersCreateRoute
  '/account': typeof AuthAccountIndexRoute
  '/administration': typeof AuthAdministrationIndexRoute
  '/coverage-map': typeof AuthCoverageMapIndexRoute
  '/devices': typeof AuthDevicesIndexRoute
  '/partners': typeof AuthPartnersIndexRoute
  '/subscribers': typeof AuthSubscribersIndexRoute
  '/usage': typeof AuthUsageIndexRoute
  '/administration/auth-groups/$authGroupId': typeof AuthAdministrationAuthGroupsAuthGroupIdRoute
  '/administration/auth-groups/create': typeof AuthAdministrationAuthGroupsCreateRoute
  '/administration/certificates/$id': typeof AuthAdministrationCertificatesIdRoute
  '/administration/certificates/create': typeof AuthAdministrationCertificatesCreateRoute
  '/administration/users/$userId': typeof AuthAdministrationUsersUserIdRoute
  '/administration/users/create': typeof AuthAdministrationUsersCreateRoute
  '/administration/apikeys': typeof AuthAdministrationApikeysIndexRoute
  '/administration/auth-groups': typeof AuthAdministrationAuthGroupsIndexRoute
  '/administration/certificates': typeof AuthAdministrationCertificatesIndexRoute
  '/administration/users': typeof AuthAdministrationUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/help': typeof HelpRoute
  '/login': typeof LoginRoute
  '/recovery': typeof RecoveryRoute
  '/registration': typeof RegistrationRoute
  '/settings': typeof SettingsRoute
  '/_auth/devices/$username': typeof AuthDevicesUsernameRoute
  '/_auth/devices/bulk-management': typeof AuthDevicesBulkManagementRoute
  '/_auth/devices/create': typeof AuthDevicesCreateRoute
  '/_auth/partners/$partnerId': typeof AuthPartnersPartnerIdRoute
  '/_auth/partners/create': typeof AuthPartnersCreateRoute
  '/_auth/subscribers/$subscriberId': typeof AuthSubscribersSubscriberIdRoute
  '/_auth/subscribers/create': typeof AuthSubscribersCreateRoute
  '/_auth/account/': typeof AuthAccountIndexRoute
  '/_auth/administration/': typeof AuthAdministrationIndexRoute
  '/_auth/coverage-map/': typeof AuthCoverageMapIndexRoute
  '/_auth/devices/': typeof AuthDevicesIndexRoute
  '/_auth/partners/': typeof AuthPartnersIndexRoute
  '/_auth/subscribers/': typeof AuthSubscribersIndexRoute
  '/_auth/usage/': typeof AuthUsageIndexRoute
  '/_auth/administration/auth-groups/$authGroupId': typeof AuthAdministrationAuthGroupsAuthGroupIdRoute
  '/_auth/administration/auth-groups/create': typeof AuthAdministrationAuthGroupsCreateRoute
  '/_auth/administration/certificates/$id': typeof AuthAdministrationCertificatesIdRoute
  '/_auth/administration/certificates/create': typeof AuthAdministrationCertificatesCreateRoute
  '/_auth/administration/users/$userId': typeof AuthAdministrationUsersUserIdRoute
  '/_auth/administration/users/create': typeof AuthAdministrationUsersCreateRoute
  '/_auth/administration/apikeys/': typeof AuthAdministrationApikeysIndexRoute
  '/_auth/administration/auth-groups/': typeof AuthAdministrationAuthGroupsIndexRoute
  '/_auth/administration/certificates/': typeof AuthAdministrationCertificatesIndexRoute
  '/_auth/administration/users/': typeof AuthAdministrationUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/help'
    | '/login'
    | '/recovery'
    | '/registration'
    | '/settings'
    | '/devices/$username'
    | '/devices/bulk-management'
    | '/devices/create'
    | '/partners/$partnerId'
    | '/partners/create'
    | '/subscribers/$subscriberId'
    | '/subscribers/create'
    | '/account/'
    | '/administration/'
    | '/coverage-map/'
    | '/devices/'
    | '/partners/'
    | '/subscribers/'
    | '/usage/'
    | '/administration/auth-groups/$authGroupId'
    | '/administration/auth-groups/create'
    | '/administration/certificates/$id'
    | '/administration/certificates/create'
    | '/administration/users/$userId'
    | '/administration/users/create'
    | '/administration/apikeys/'
    | '/administration/auth-groups/'
    | '/administration/certificates/'
    | '/administration/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/help'
    | '/login'
    | '/recovery'
    | '/registration'
    | '/settings'
    | '/devices/$username'
    | '/devices/bulk-management'
    | '/devices/create'
    | '/partners/$partnerId'
    | '/partners/create'
    | '/subscribers/$subscriberId'
    | '/subscribers/create'
    | '/account'
    | '/administration'
    | '/coverage-map'
    | '/devices'
    | '/partners'
    | '/subscribers'
    | '/usage'
    | '/administration/auth-groups/$authGroupId'
    | '/administration/auth-groups/create'
    | '/administration/certificates/$id'
    | '/administration/certificates/create'
    | '/administration/users/$userId'
    | '/administration/users/create'
    | '/administration/apikeys'
    | '/administration/auth-groups'
    | '/administration/certificates'
    | '/administration/users'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/help'
    | '/login'
    | '/recovery'
    | '/registration'
    | '/settings'
    | '/_auth/devices/$username'
    | '/_auth/devices/bulk-management'
    | '/_auth/devices/create'
    | '/_auth/partners/$partnerId'
    | '/_auth/partners/create'
    | '/_auth/subscribers/$subscriberId'
    | '/_auth/subscribers/create'
    | '/_auth/account/'
    | '/_auth/administration/'
    | '/_auth/coverage-map/'
    | '/_auth/devices/'
    | '/_auth/partners/'
    | '/_auth/subscribers/'
    | '/_auth/usage/'
    | '/_auth/administration/auth-groups/$authGroupId'
    | '/_auth/administration/auth-groups/create'
    | '/_auth/administration/certificates/$id'
    | '/_auth/administration/certificates/create'
    | '/_auth/administration/users/$userId'
    | '/_auth/administration/users/create'
    | '/_auth/administration/apikeys/'
    | '/_auth/administration/auth-groups/'
    | '/_auth/administration/certificates/'
    | '/_auth/administration/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  HelpRoute: typeof HelpRoute
  LoginRoute: typeof LoginRoute
  RecoveryRoute: typeof RecoveryRoute
  RegistrationRoute: typeof RegistrationRoute
  SettingsRoute: typeof SettingsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recovery': {
      id: '/recovery'
      path: '/recovery'
      fullPath: '/recovery'
      preLoaderRoute: typeof RecoveryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/registration': {
      id: '/registration'
      path: '/registration'
      fullPath: '/registration'
      preLoaderRoute: typeof RegistrationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/account/': {
      id: '/_auth/account/'
      path: '/account'
      fullPath: '/account/'
      preLoaderRoute: typeof AuthAccountIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/administration/': {
      id: '/_auth/administration/'
      path: '/administration'
      fullPath: '/administration/'
      preLoaderRoute: typeof AuthAdministrationIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/coverage-map/': {
      id: '/_auth/coverage-map/'
      path: '/coverage-map'
      fullPath: '/coverage-map/'
      preLoaderRoute: typeof AuthCoverageMapIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/devices/': {
      id: '/_auth/devices/'
      path: '/devices'
      fullPath: '/devices/'
      preLoaderRoute: typeof AuthDevicesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/devices/$username': {
      id: '/_auth/devices/$username'
      path: '/devices/$username'
      fullPath: '/devices/$username'
      preLoaderRoute: typeof AuthDevicesUsernameRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/devices/bulk-management': {
      id: '/_auth/devices/bulk-management'
      path: '/devices/bulk-management'
      fullPath: '/devices/bulk-management'
      preLoaderRoute: typeof AuthDevicesBulkManagementRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/devices/create': {
      id: '/_auth/devices/create'
      path: '/devices/create'
      fullPath: '/devices/create'
      preLoaderRoute: typeof AuthDevicesCreateRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/partners/': {
      id: '/_auth/partners/'
      path: '/partners'
      fullPath: '/partners/'
      preLoaderRoute: typeof AuthPartnersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/partners/$partnerId': {
      id: '/_auth/partners/$partnerId'
      path: '/partners/$partnerId'
      fullPath: '/partners/$partnerId'
      preLoaderRoute: typeof AuthPartnersPartnerIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/partners/create': {
      id: '/_auth/partners/create'
      path: '/partners/create'
      fullPath: '/partners/create'
      preLoaderRoute: typeof AuthPartnersCreateRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/subscribers/': {
      id: '/_auth/subscribers/'
      path: '/subscribers'
      fullPath: '/subscribers/'
      preLoaderRoute: typeof AuthSubscribersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/subscribers/$subscriberId': {
      id: '/_auth/subscribers/$subscriberId'
      path: '/subscribers/$subscriberId'
      fullPath: '/subscribers/$subscriberId'
      preLoaderRoute: typeof AuthSubscribersSubscriberIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/subscribers/create': {
      id: '/_auth/subscribers/create'
      path: '/subscribers/create'
      fullPath: '/subscribers/create'
      preLoaderRoute: typeof AuthSubscribersCreateRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/usage/': {
      id: '/_auth/usage/'
      path: '/usage'
      fullPath: '/usage/'
      preLoaderRoute: typeof AuthUsageIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/administration/apikeys/': {
      id: '/_auth/administration/apikeys/'
      path: '/administration/apikeys'
      fullPath: '/administration/apikeys/'
      preLoaderRoute: typeof AuthAdministrationApikeysIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/administration/auth-groups/': {
      id: '/_auth/administration/auth-groups/'
      path: '/administration/auth-groups'
      fullPath: '/administration/auth-groups/'
      preLoaderRoute: typeof AuthAdministrationAuthGroupsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/administration/auth-groups/$authGroupId': {
      id: '/_auth/administration/auth-groups/$authGroupId'
      path: '/administration/auth-groups/$authGroupId'
      fullPath: '/administration/auth-groups/$authGroupId'
      preLoaderRoute: typeof AuthAdministrationAuthGroupsAuthGroupIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/administration/auth-groups/create': {
      id: '/_auth/administration/auth-groups/create'
      path: '/administration/auth-groups/create'
      fullPath: '/administration/auth-groups/create'
      preLoaderRoute: typeof AuthAdministrationAuthGroupsCreateRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/administration/certificates/': {
      id: '/_auth/administration/certificates/'
      path: '/administration/certificates'
      fullPath: '/administration/certificates/'
      preLoaderRoute: typeof AuthAdministrationCertificatesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/administration/certificates/$id': {
      id: '/_auth/administration/certificates/$id'
      path: '/administration/certificates/$id'
      fullPath: '/administration/certificates/$id'
      preLoaderRoute: typeof AuthAdministrationCertificatesIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/administration/certificates/create': {
      id: '/_auth/administration/certificates/create'
      path: '/administration/certificates/create'
      fullPath: '/administration/certificates/create'
      preLoaderRoute: typeof AuthAdministrationCertificatesCreateRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/administration/users/': {
      id: '/_auth/administration/users/'
      path: '/administration/users'
      fullPath: '/administration/users/'
      preLoaderRoute: typeof AuthAdministrationUsersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/administration/users/$userId': {
      id: '/_auth/administration/users/$userId'
      path: '/administration/users/$userId'
      fullPath: '/administration/users/$userId'
      preLoaderRoute: typeof AuthAdministrationUsersUserIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/administration/users/create': {
      id: '/_auth/administration/users/create'
      path: '/administration/users/create'
      fullPath: '/administration/users/create'
      preLoaderRoute: typeof AuthAdministrationUsersCreateRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthDevicesUsernameRoute: typeof AuthDevicesUsernameRoute
  AuthDevicesBulkManagementRoute: typeof AuthDevicesBulkManagementRoute
  AuthDevicesCreateRoute: typeof AuthDevicesCreateRoute
  AuthPartnersPartnerIdRoute: typeof AuthPartnersPartnerIdRoute
  AuthPartnersCreateRoute: typeof AuthPartnersCreateRoute
  AuthSubscribersSubscriberIdRoute: typeof AuthSubscribersSubscriberIdRoute
  AuthSubscribersCreateRoute: typeof AuthSubscribersCreateRoute
  AuthAccountIndexRoute: typeof AuthAccountIndexRoute
  AuthAdministrationIndexRoute: typeof AuthAdministrationIndexRoute
  AuthCoverageMapIndexRoute: typeof AuthCoverageMapIndexRoute
  AuthDevicesIndexRoute: typeof AuthDevicesIndexRoute
  AuthPartnersIndexRoute: typeof AuthPartnersIndexRoute
  AuthSubscribersIndexRoute: typeof AuthSubscribersIndexRoute
  AuthUsageIndexRoute: typeof AuthUsageIndexRoute
  AuthAdministrationAuthGroupsAuthGroupIdRoute: typeof AuthAdministrationAuthGroupsAuthGroupIdRoute
  AuthAdministrationAuthGroupsCreateRoute: typeof AuthAdministrationAuthGroupsCreateRoute
  AuthAdministrationCertificatesIdRoute: typeof AuthAdministrationCertificatesIdRoute
  AuthAdministrationCertificatesCreateRoute: typeof AuthAdministrationCertificatesCreateRoute
  AuthAdministrationUsersUserIdRoute: typeof AuthAdministrationUsersUserIdRoute
  AuthAdministrationUsersCreateRoute: typeof AuthAdministrationUsersCreateRoute
  AuthAdministrationApikeysIndexRoute: typeof AuthAdministrationApikeysIndexRoute
  AuthAdministrationAuthGroupsIndexRoute: typeof AuthAdministrationAuthGroupsIndexRoute
  AuthAdministrationCertificatesIndexRoute: typeof AuthAdministrationCertificatesIndexRoute
  AuthAdministrationUsersIndexRoute: typeof AuthAdministrationUsersIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthDevicesUsernameRoute: AuthDevicesUsernameRoute,
  AuthDevicesBulkManagementRoute: AuthDevicesBulkManagementRoute,
  AuthDevicesCreateRoute: AuthDevicesCreateRoute,
  AuthPartnersPartnerIdRoute: AuthPartnersPartnerIdRoute,
  AuthPartnersCreateRoute: AuthPartnersCreateRoute,
  AuthSubscribersSubscriberIdRoute: AuthSubscribersSubscriberIdRoute,
  AuthSubscribersCreateRoute: AuthSubscribersCreateRoute,
  AuthAccountIndexRoute: AuthAccountIndexRoute,
  AuthAdministrationIndexRoute: AuthAdministrationIndexRoute,
  AuthCoverageMapIndexRoute: AuthCoverageMapIndexRoute,
  AuthDevicesIndexRoute: AuthDevicesIndexRoute,
  AuthPartnersIndexRoute: AuthPartnersIndexRoute,
  AuthSubscribersIndexRoute: AuthSubscribersIndexRoute,
  AuthUsageIndexRoute: AuthUsageIndexRoute,
  AuthAdministrationAuthGroupsAuthGroupIdRoute:
    AuthAdministrationAuthGroupsAuthGroupIdRoute,
  AuthAdministrationAuthGroupsCreateRoute:
    AuthAdministrationAuthGroupsCreateRoute,
  AuthAdministrationCertificatesIdRoute: AuthAdministrationCertificatesIdRoute,
  AuthAdministrationCertificatesCreateRoute:
    AuthAdministrationCertificatesCreateRoute,
  AuthAdministrationUsersUserIdRoute: AuthAdministrationUsersUserIdRoute,
  AuthAdministrationUsersCreateRoute: AuthAdministrationUsersCreateRoute,
  AuthAdministrationApikeysIndexRoute: AuthAdministrationApikeysIndexRoute,
  AuthAdministrationAuthGroupsIndexRoute:
    AuthAdministrationAuthGroupsIndexRoute,
  AuthAdministrationCertificatesIndexRoute:
    AuthAdministrationCertificatesIndexRoute,
  AuthAdministrationUsersIndexRoute: AuthAdministrationUsersIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  HelpRoute: HelpRoute,
  LoginRoute: LoginRoute,
  RecoveryRoute: RecoveryRoute,
  RegistrationRoute: RegistrationRoute,
  SettingsRoute: SettingsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
